<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <van-empty description="暂无数据" class="mt50" v-if="list.length == 0" />
  <div class="culture scroll" style="height: calc(100vh - 44px)" ref="wrapper" @scroll.passive="isScrollBottom">
    <div class="culture-list" v-for="(item, index) in list" :key="index">
      <div class="culture-list-left" @click="goDetail(item)">
        <p class="b500">{{ item.name }}</p>
        <p>{{ item.add_time }}</p>
      </div>
      <div class="culture-list-right">
        <div v-if="item.invest == 0">
          <div class="cul-tip" @click="handleCulTip(item.id, item.cate_id, item.is_invest)">
            去投资
          </div>
        </div>
        <div v-if="item.invest != 0" @click="handleCulTip(item.id, item.cate_id, item.is_invest)">
          <p>投资</p>
          <p>¥{{ item.invest }}</p>
        </div>
        <div v-if="item.score == 0" @click="goScore(item)">
          <!-- <router-link :to="{
              path: '/culture',
              query: {
                tzid: item.id,
                type: 'tzpf',
                cateId: item.cate_id,
                tle: item.name,
              },
            }">去评分</router-link> -->
          <div>去评分</div>
        </div>
        <div @click="goScore(item)" v-if="item.score != 0">
          <p>评分</p>
          <p>{{ item.score }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { showFailToast } from "vant";
export default {
  name: "myCulture",
  data () {
    return {
      list: [],
      count: 0,
    };
  },
  methods: {
    // 跳转评分页面
    goScore (item) {
      this.$router.push({
        path: '/culture',
        query: {
          tzid: item.id,
          type: 'tzpf',
          cateId: item.cate_id,
          tle: item.name,
        }
      })
    },
    // 跳转对应页面
    goDetail (item) {
      this.$router.push({
        path: `/culture/cate${item.cate_id}`,
        query: { id: item.id }
      })
    },
    // :to="{
    //           path: '/culture/myinvestment',
    //           query: { id: item.id, cateId: item.cate_id },
    //         }"
    handleCulTip (id, cate_id, is_invest) {
      if (is_invest < 1) {
        showFailToast({
          message: "未开启投资",
        });
        return
      }

      this.$router.push({ path: '/culture/myinvestment', query: { id: id, cateId: cate_id } })

    },

    getList (page) {
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return (this.page = this.count);
        }
      } else {
        list = [];
      }
      this.ajax
        .post("users/getcivilizationlist", { page: this.page })
        .then(({ data, count }) => {
          this.list = list.concat(data);
          this.count = count;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper;
      var clientHeight = this.box.clientHeight;
      var scrollTop = this.box.scrollTop;
      var scrollHeight = this.box.scrollHeight;
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    },
    next () {
      history.forward();
    },
  },
  created () {
    this.getList();
  },
};
</script>
<script setup>
import { nextFn } from "@/utils/type.js";
//右箭头
const next = () => {
  nextFn();
};
</script>
<style scoped>
.culture-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4vw 4.2667vw;
  border-bottom: 1px solid #f6f6f6;
}
.culture-list-left p {
  font-size: 14px;
}
.culture-list-left p:first-child {
  color: #333333;
}
.culture-list-left p:last-child {
  color: #666666;
  margin-top: 4.2667vw;
}
.culture-list-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.culture-list-right p {
  text-align: center;
}
.culture-list-right div:first-child {
  color: #ff0000;
  font-size: 12px;
  width: 14vw;
  text-align: center;
}
.culture-list-right div:first-child p:last-child {
  font-size: 14px;
}
.culture-list-right div:last-child {
  color: #3f7c93;
  font-size: 12px;
  /* margin-left: 10.1333vw; */
  width: 14vw;
  text-align: center;
}
.culture-list-right div:last-child p:last-child {
  font-size: 14px;
}
.cul-tip {
  color: #ff0000 !important;
}
</style>